import React, { useEffect, useState } from 'react';
import { Marker } from "@react-google-maps/api";

const MyLocationMarker = ({ mapInstance }) => {
  const [currentLocation, setCurrentLocation] = useState(null);
//   const [heading, setHeading] = useState(50);

  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCurrentLocation({ lat: latitude, lng: longitude });
        },
        (error) => {
          console.error('Error getting user location:', error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  };

//   const getDeviceOrientation = async () => {
//     if (!window.DeviceOrientationEvent || window.DeviceOrientationEvent.requestPermission) {
//       alert('Your current device does not have access to device orientation information.');
//     } else if (Notification.permission !== 'granted') {
//       try {
//         const permission = await window.DeviceOrientationEvent.requestPermission();
//         if (permission !== 'granted') {
//           alert('You must grant access to device orientation information.');
//         }
//       } catch (error) {
//         console.error('Error requesting device orientation permission:', error);
//       }
//     }
  
//     window.addEventListener('deviceorientation', deviceOrientationHandler, true);
//   };

//   const deviceOrientationHandler = (event) => {
//     if (event.alpha !== null) {
//       console.log('Orientation:', event.alpha);
//       setHeading(event.alpha);
//     }
//   };

  useEffect(() => {
    
    // Get user's current location when the component mounts
    getUserLocation();

    // Set up a watch position to continuously update the user's location
    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        console.log('Watch position:',position )
        setCurrentLocation({ lat: latitude, lng: longitude });
      },
      (error) => {
        console.error('Error watching user location:', error);
      },
      {
        enableHighAccuracy: true,
        timeout: 1_000, // Reduced timeout to 1 second
        maximumAge: 500,
      }
    );

    // Get user's device orientation
    // getDeviceOrientation()
    
    // Cleanup function to clear the watch position when the component unmounts
    return () => {
      navigator.geolocation.clearWatch(watchId);
    //   window.removeEventListener('deviceorientation', deviceOrientationHandler);
    };
  }, []); // Empty dependency array to run the effect only once when the component mounts

  return currentLocation && mapInstance ? (
    <Marker
      position={currentLocation}
      icon={{
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
          `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#4285F4" stroke="#ffffff" stroke-width="2"><circle cx="12" cy="12" r="8" fill="#4285F4" stroke="#ffffff"/></svg>`
        ),
        scaledSize: new window.google.maps.Size(24, 24), // Adjust the size if needed
      }}
    />
  ) : null;
};

export default MyLocationMarker;

// DIRECTION MARKER
// const rotationTransform = `rotate(${heading} 12 12)`;

// return currentLocation && mapInstance ? (
//   <Marker
//     position={currentLocation}
//     icon={{
//       url: `data:image/svg+xml;charset=UTF-8,` + encodeURIComponent(
//         `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="34" height="34" fill="#4285F4" stroke="#ffffff" stroke-width="2">
//           <g transform="${rotationTransform}">
//             <polygon points="12,4 2,20 12,14 22,20" />
//             <line x1="12" y1="14" x2="12" y2="4" />
//           </g>
//         </svg>`
//       ),
//       scaledSize: new window.google.maps.Size(24, 24),
//     }}
//   />
// ) : null;